import React, {useState} from 'react';

import UserDetails from "../../components/user-details/user-details.jsx";
import FileUpload from "../../components/file-upload/file-upload.jsx";
import OrderReview from "../../components/order-review/order-review.jsx";
import {proceed} from   "../../services/finalize";

import {
    getTotalPrice,
    getAdditionalInformationForDB,
    getOrderDescriptionForDB
} from '../../services/cart';

const Review = (props)=>{

    const{
        teethState,
        setCurrency,
        fieldsState,
        setFields,
        bridges,
        currency,
        setCurScreen,
        appFiles,
        setAppFiles
    } = props;

    const [isLoading,changeIsLoading] = useState(false);

    const  stopLoading = ()=>{changeIsLoading(false)}

    return(
        <div className='wrapper'>
            <div className='left-wrap'>
                <div className='header flex'>
                    <h1>{abraStr.review}</h1>
                    <p
                        className="edit-order"
                        onClick={()=>{setCurScreen("planning")}}
                    >
                        {abraStr.editOrder}
                    </p>
                </div>
                <OrderReview
                    teethState={teethState}
                    currency={currency}
                    bridges={bridges}
                />
                <p className='abra-total'>{`${abraStr.totalPrice}: ${getTotalPrice(teethState,currency,bridges)}`}</p>
                <FileUpload
                    appFiles={appFiles}
                    setAppFiles={setAppFiles}
                />
                <div className='flex'>
                    <button
                        id='proceed'
                        disabled={isLoading}
                        onClick={()=>{
                            const additionalInformation = getAdditionalInformationForDB(fieldsState);
                            const orderSummary = getOrderDescriptionForDB(teethState,currency,bridges);
                            changeIsLoading(true);
                            proceed(
                                appFiles,
                                fieldsState,
                                additionalInformation,
                                orderSummary,
                                currency,
                                getTotalPrice(teethState,currency,bridges,true),
                                stopLoading
                            );
                        }}
                    >
                        {abraStr.proceed}
                    </button>
                    {isLoading && <div className='loader'/> }
                </div>

            </div>
            <div className='right-wrap'>
                <div id='additional-info' className="greyed">
                    <p className='additional'>{abraStr.additionalInfo}</p>
                    <div className="blocker"/>
                    <div className='summary'>
                        <div className='top'>
                            <UserDetails
                                setCurrency={setCurrency}
                                fieldsState={fieldsState}
                                setFields={setFields}
                                setCurScreen={setCurScreen}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Review;